import { useTranslation } from "react-i18next";
import styles from "./StatusComponent.module.scss";

interface Props {
  statusCode: string;
}

const StatusComponent: React.FC<Props> = ({ statusCode }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.base + " " + styles[statusCode]}>
        <div>{t(`publicationStatus.${statusCode}`)}</div>
      </div>
    </>
  );
};

export default StatusComponent;
